export default function(
  state = {
    deletedCustomField: {},
    currentCustomFields: [],
    tempId: new Date().getTime(),
    whatsUsingThem: "",
  },
  action
) {
  switch (action.type) {
    case "DELETE_CUSTOM_FIELD":
      return Object.assign({}, state, {
        deletedCustomField: action.deletedCustomField,
      });
    case "SET_WHATS_USING":
      return Object.assign({}, state, {
        whatsUsingThem: action.whatsUsingThem,
      });
    case "SET_CUSTOM_FIELDS":
      let newTempId = new Date().getTime();
      return Object.assign({}, state, {
        currentCustomFields: action.currentCustomFields,
        tempId: newTempId + 1,
      });
    case "SET_TEMPID":
      return Object.assign({}, state, {
        tempId: action.tempId,
      });
    default:
      return state;
  }
}
